import React from 'react';
import { PropTypes } from 'prop-types';
import { AssignProperties, DisplayErrors, PreventDOMLock } from '../../shared/utils';
import { ButtonBusyIndicatorComponent } from '../../shared/buttonBusyIndicatorComponent';
import { ModalBase } from '../../shared/messageBoxComponent';

export class EditNotesDialogComponent extends React.Component {
    constructor(props, ...others) {
        super(props, ...others);
        this.strings = {...this.constructor.defaultProps.strings};
        AssignProperties(this.strings, props.strings);

        this.state = {
            notes: props.notes,
            isSaving: false,
        }

        this.modalRef = React.createRef();
        this.handleModalHide = this.handleModalHide.bind(this);
        this.handleSaveClick = this.handleSaveClick.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.doSave = this.doSave.bind(this);
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    handleChange(e) {
        const self = this;
        const value = e.target.value;

        // PreventDOMLock(() => {
        //     if (self._isMounted) {
        //         self.setState({notes: value});
        //     }
        // });
        if (self._isMounted) {
            self.setState({notes: value});
        }
    }

    handleModalHide(e) {
        const self = this;
        if (self._isMounted) {
            PreventDOMLock(self.props.onHide);
        }
    }

    handleSaveClick() {
        const self = this;

        PreventDOMLock(self.doSave);
    }

    doSave() {
        const self = this;

        if (self._isMounted) {
            new Promise(resolve => self.setState({isSaving: true}, resolve))
                .then(() => {
                    if (self._isMounted) {
                        return self.props.doSave(self.state.notes);
                    }
                })
                .then(() => {
                    if (self._isMounted) {
                        ModalBase.HideModal(self.modalRef.current);
                    }
                })
                .catch(errors => {
                    if (self._isMounted) {
                        DisplayErrors(errors);
                        self.setState({isSaving: false});
                    }
                });
        }
    }

    render() {
        const self = this;
        const {isSaving, notes} = self.state;
        const {title, size, doSave, onShow} = self.props;
        const strings = self.strings;

        return (
            <ModalBase 
                ref={self.modalRef}
                visible
                animated
                autoFocus
                allowClose={!isSaving}
                size={size}
                title={title}
                body={
                    <textarea
                        className="form-control compact"
                        readOnly={isSaving}
                        value={notes || ''}
                        onChange={self.handleChange}
                        rows={10}
                    />
                }
                footer={
                    <div>
                        <button 
                            type="button" 
                            onClick={self.handleSaveClick} 
                            className="btn btn-sm btn-outline-primary newstyle"
                            disabled={isSaving || (typeof doSave != 'function')}
                        >
                            {strings.BTN_Save}
                            <ButtonBusyIndicatorComponent visible={isSaving} />
                        </button>
                    </div>
                }
                onHide={self.handleModalHide}
                onShow={onShow}
            />
        )
    }
}
EditNotesDialogComponent.propTypes = {
    strings: PropTypes.object,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    size: PropTypes.oneOf(['sm', 'lg', 'xl']),
    notes: PropTypes.string,
    onShow: PropTypes.func,
    onHide: PropTypes.func,
    doSave: PropTypes.func, //Must returns Promise
}
EditNotesDialogComponent.defaultProps = {
    strings: {
        BTN_Save: 'Save',
    },
    size: 'lg',
}